"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
function useForceUpdate() {
    var _a = tslib_1.__read(React.useReducer(function (x) { return x + 1; }, 0), 2), forceUpdate = _a[1];
    return forceUpdate;
}
exports.default = useForceUpdate;
//# sourceMappingURL=useForceUpdate.js.map